<template>
  <div :style="{ height: boxHeightRem + 'rem' }">
    <Mobile/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Mobile from '@/components/MobileModule.vue'

export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true,
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  mounted() {
    this.HEIGHT_VIEW()
   
  },
  computed: {
    ...mapGetters(['innerHeightRem']),
    boxHeightRem() {
      return this.innerHeightRem
    },
    winInnHeight() {
      if (window.innerHeight) {
        return window.innerHeight
      }
      return 0
    },
    IsPC() { // 判断移动端
      let userAgentInfo = navigator.userAgent
      let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
      let flag = true
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      return flag
    }
  },
  components: {
    Mobile
  },
  methods: {
    addToHomeScreen(){
    },
    addToHome () {
    },
    generateMobileConfig() {
    },
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    getPlatform() {
      return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? -1 != navigator.userAgent.indexOf("cordova") && -1 != navigator.userAgent.indexOf("iphone") ? "ios" : -1 != navigator.userAgent.indexOf("cordova") && -1 != navigator.userAgent.indexOf("android") ? "android" : -1 != navigator.userAgent.indexOf("MicroMessenger") ? "wechat" : "wap" : "pc"
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: default;
  text-align: center;
  color: #fff;
}

@media only screen and (min-width: 500px) {

  html,
  body {
    width: 375px;
    margin: 0 auto;
  }
}

* {
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0 0 auto;
  font-size: 14px;
}

img {
  width: 100%;
  height: 100%;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

::-webkit-scrollbar {
  width: 0 !important
}

::-webkit-scrollbar {
  -ms-overflow-style: none;
}

::-webkit-scrollbar {
  overflow: -moz-scrollbars-none;
}
</style>
